// extracted by mini-css-extract-plugin
export default {"about_columns":"About_about_columns__NXhqq","lisa_img":"About_lisa_img__2W48z","about_block":"About_about_block__au7eS","btn":"About_btn__WT77y"};